<script setup>
import { computed } from 'vue'
import OverviewWorkloadBar from './OverviewWorkloadBar.vue'
import { getColleagueColor } from '../../../composables/useReservationsCalendar.js'
import { useOverviewStore } from '../../../../../state/overviewStore.js'

const store    = useOverviewStore()
const workload = computed(() => store.currentWorkload)
</script>

<template>
    <div>
        <div v-if="!workload.length" class="text-[13px] text-gray-400 dark:text-neutral-500 py-3">{{ $t('dashboard.workload_empty') }}</div>
        <OverviewWorkloadBar
            v-for="(w, i) in workload"
            :key="w.id"
            :worker="w"
            :color="getColleagueColor(i)"
        />
    </div>
</template>
